import React from 'react';
import cx from 'classnames';
import ContentView from '../../ContentView';
import '../styles/_comment-body.scss';






function CommentBody({ content, small }) {
  return (
    <div className={cx('comment-body', { 'comment-body--small': small })}>
      <ContentView content={content} truncate />
    </div>);

}

export default CommentBody;